import { ReactNode } from "react";
import { SubNav, SubNavTab } from "@/components/layout/SubNav";

interface SentimentLayoutProps {
  children: ReactNode;
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

const sentimentTabs: SubNavTab[] = [
  { label: "Dashboard", path: "/sentiment/dashboard" },
  { label: "Config", path: "/sentiment/config" },
];

export const SentimentLayout = ({ children, onRefresh, isRefreshing }: SentimentLayoutProps) => {
  return (
    <div className="flex flex-col h-full">
      <SubNav tabs={sentimentTabs} onRefresh={onRefresh} isRefreshing={isRefreshing} />
      <main className="flex-1 overflow-y-auto bg-[#F5F5F5]">
        {children}
      </main>
    </div>
  );
};
